import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Loader2 } from "lucide-react";

const STEPS = [
  "Leyendo tu sitio…",
  "Revisando formularios y consentimientos…",
  "Detectando scripts de terceros…",
  "Buscando política de privacidad y derechos ARCO…",
  "Consultando la Ley 21.719…",
  "Generando informe personalizado…",
];

export default function LoadingScreen({ url }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % STEPS.length);
    }, 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      data-testid="loading-screen"
      className="min-h-[70vh] px-6 py-16 flex items-center justify-center"
    >
      <div className="max-w-xl mx-auto text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-[#1E3A8A]/5 grid place-items-center mb-8">
          <Loader2 className="w-9 h-9 text-[#1E3A8A] animate-spin" />
        </div>

        <p className="text-xs font-semibold tracking-wider uppercase text-slate-500">
          Analizando
        </p>
        <p
          data-testid="loading-url"
          className="mt-2 font-display text-xl sm:text-2xl font-semibold text-slate-900 break-all"
        >
          {url}
        </p>

        <div className="mt-10 h-8 relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.45 }}
              className="absolute inset-0 text-base text-slate-600"
              data-testid={`loading-step-${idx}`}
            >
              {STEPS[idx]}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-8 w-full max-w-sm mx-auto h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <motion.div
            initial={{ x: "-40%" }}
            animate={{ x: "120%" }}
            transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
            className="h-full w-1/3 bg-[#1E3A8A] rounded-full"
          />
        </div>

        <p className="mt-10 text-xs text-slate-400">
          Esto puede tomar entre 10 y 30 segundos.
        </p>
      </div>
    </section>
  );
}
